import React from "react"
import { JsonLd } from "react-schemaorg"
import { BreadcrumbList } from "schema-dts"
import { absoluteUrl } from "../../../root/routing/path"
import { BreadcrumbSegment } from "../../../ui/organisms/HeroBreadcrumb"

interface Props {
  segments: BreadcrumbSegment[]
}

const BreadcrumbJsonLD = ({ segments }: Props) => {
  return (
    <JsonLd<BreadcrumbList>
      item={{
        "@context": "https://schema.org/" as any,
        "@type": "BreadcrumbList",
        itemListElement: segments.map((x, index) => ({
          "@type": "ListItem",
          position: index + 1,
          item: {
            "@id": absoluteUrl(x.url ?? ""),
            name: x.name,
          },
        })),
      }}
    />
  )
}

export default BreadcrumbJsonLD
